import React from 'react';
import ReactDOM from 'react-dom/client';
import Paths from './paths';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Paths />
  </React.StrictMode>
);